<template>
  <transition :duration="300">
    <div v-if="selection.length > 0"
        class="TicketBatchOperationBar">
        <el-button @click="batchReply"
            title="批量回复勾选的工单">批量回复</el-button>

        <el-button @click="batchUpdateStatus(6)"
            title="批量将勾选的工单的状态更新为已关闭">批量关闭</el-button>
        <el-button @click="batchUpdateStatus(5)"
            title="批量将勾选的工单的状态更新为已解决">已解决</el-button>
        <el-button @click="batchUpdateStatus(3)"
            title="批量将勾选的工单的状态更新为处理中">处理中</el-button>
        <el-button @click="batchUpdateStatus(2)"
            title="批量将勾选的工单的状态更新为待受理">待受理</el-button>

        <el-button @click="batchUpdatePriority(5)"
            title="批量将勾选的工单的优先级更新为紧急(P5)">紧急(P5)</el-button>
        <el-button @click="batchUpdatePriority(4)"
            title="批量将勾选的工单的优先级更新为P4">P4</el-button>
        <el-button @click="batchUpdatePriority(3)"
            title="批量将勾选的工单的优先级更新为P3">P3</el-button>
        <el-button @click="batchUpdatePriority(2)"
            title="批量将勾选的工单的优先级更新为P2">P2</el-button>
        <el-button @click="batchUpdatePriority(1)"
            title="批量将勾选的工单的优先级更新为一般(P1)">一般(P1)</el-button>

        <el-button @click="batchAccept"
            title="批量受理工单">批量受理</el-button>

        <el-button @click="batchUpdateTicketType"
            title="批量修改工单类型">修改类型</el-button>

        <el-button @click="batchAssign"
            title="批量指派工单">指派</el-button>

        <el-button
            @click="onClose"
            style="float:right;margin-right:250px;"
            title="取消选择所有工单">取消选择</el-button>

        <el-dialog
            title="批量回复"
            :visible.sync="batchReplyDialogVisible"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            width="60%">
            <el-form
                :inline="true"
                style="padding-left:10px;padding-right:10px;">
                <EditorSummernote v-model="replyContent"/>

                <TicketUploadList ref="upList2"
                    @clear="() => { this.$refs.up4.clearFile(); }"
                    @delete="e => { this.$refs.up4.deleteFile(e); }"/>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <span style="float:left;padding-left:20px;">
                    <TicketTemplateSelect @selected="onTicketTemplateSelected"/>

                    <TicketUpload ref="up4"
                        @change="e => { this.$refs.upList2.setAttachmentList(e); }"/>
                </span>

                <el-button @click="batchReplyDialogVisible=false">取消</el-button>

                <ReplyTicketButton @click="postBatchReply" />
            </span>
        </el-dialog>

        <el-dialog
            title="批量修改工单类型"
            :visible.sync="batchUpdateTicketTypeDialogVisible"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            width="60%">
            <MobileTicketTypePicker style="margin-left:35px;margin-bottom:35px;" v-model="ticketType"/>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="postBatchUpdateTicketType">确定</el-button>
                <el-button @click="batchUpdateTicketTypeDialogVisible=false">取消</el-button>
            </span>
        </el-dialog>

        <TicketAssignDialog ref="ticketAssignDialog" @submit="postBatchAssign"/>
    </div>
  </transition>
</template>

<script>
export default {
  name: "TicketBatchOperationBar",

  data() {
      return {
          selection: [],
          batchReplyDialogVisible: false,
          batchUpdateTicketTypeDialogVisible: false,
          replyContent: null,
          ticketType: null
      };
  },

  methods : {
    onClose() {
        this.$emit('cancel','');
    },

    selectionChange( _val ) {
        this.selection = _val;
    },

    batchAssign() {
        this.$refs.ticketAssignDialog.show();
    },

    postBatchAssign(e) {
        _message("postBatchAssign " + JSON.stringify(e));
    },

    batchUpdateTicketType() {
        this.batchUpdateTicketTypeDialogVisible = true;
    },

    postBatchUpdateTicketType() {
        var _this = this;
        sdk.TicketApi().batchUpdateTicketType({
            nos : this.selection.map(e => e.orderId),
            ticketTypeId : _this.ticketType,
        }).then(() => {
            _this.batchUpdateTicketTypeDialogVisible = false;

            _message("批量修改工单类型成功");
            _this.$emit('updated','');
        });
    },

    batchReply() {
        this.batchReplyDialogVisible = true;
    },

    postBatchReply( _command, status ) {
        var _visible = "privateReply" != _command;

        var _this = this;
        sdk.TicketApi().batchReply({
            nos : this.selection.map(e => e.orderId),
            content : _this.replyContent,
            visible : _visible,
            ticketAttachments : _this.$refs.up4.getAttachmentList()
        }).then(() => {
            _this.batchReplyDialogVisible = false;

            _message("批量回复工单成功");
            _this.$emit('updated','');
        });
        if (status) {
            _this.batchUpdateStatus(status, true)
        }
    },

    onTicketTemplateSelected(ticketTemplate) {
        if ( !ticketTemplate || !ticketTemplate.content ) {
            console.log("#55 ticketTemplate is empty", ticketTemplate);
            _message("模板为空");
            return;
        }

        var _editorContent = this.replyContent;
        var _newContent = "";
        if ( !!_editorContent ) {
            _newContent += _editorContent + "\r\n";
        }

        _newContent += ticketTemplate.content;

        this.replyContent = _newContent;
    },

    batchAccept() {
        if ( !confirm('确定要批量受理这 ' + this.selection.length + ' 个工单?') ) {
            return;
        }

        var _this = this;
        sdk.TicketApi().batchAccept({
            nos : this.selection.map(e => e.orderId)
        }).then(() => {
            _message("批量受理工单成功");
            _this.$emit('updated','');
        });
    },

    batchUpdateStatus( _status, dontConfirm ) {
        if ( !dontConfirm && !confirm('确定要批量更新这 ' + this.selection.length + ' 个工单的状态为 ' + _status + '?') ) {
            return;
        }

        var _this = this;
        sdk.TicketApi().batchUpdateStatus({
            nos : this.selection.map(e => e.orderId),
            status : _status
        }).then(() => {
            _message("批量更新工单状态成功");
            _this.$emit('updated','');
        });
    },

    batchUpdatePriority( _priority ) {
        if ( !confirm('确定要批量更新这 ' + this.selection.length + ' 个工单的优先级为 ' + _priority + '?') ) {
            return;
        }

        var _this = this;
        sdk.TicketApi().batchUpdatePriority({
            nos : this.selection.map(e => e.orderId),
            priority : _priority
        }).then(() => {
            _message("批量更新工单优先级成功");
            _this.$emit('updated','');
        });
    }
  }
};
</script>

<style>
.TicketBatchOperationBar {
  z-index: 9999;
  position: fixed;
  bottom: 0;
  height: 45px;
  width: 100%;
  box-shadow: 0 -1px 3px rgba(0,0,0,.15);
  background: #efefefcc;
  padding: 5px 0 5px 45px;
  margin-left: calc(-1vw + 3px);
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketBatchOperationBar.vue